import { render, staticRenderFns } from "./SwitcherOption.vue?vue&type=template&id=51235bdc&scoped=true"
import script from "./SwitcherOption.vue?vue&type=script&lang=js"
export * from "./SwitcherOption.vue?vue&type=script&lang=js"
import style0 from "./SwitcherOption.vue?vue&type=style&index=0&id=51235bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51235bdc",
  null
  
)

export default component.exports